export const compareElementsByDocumentOrder = (
  firstElement: Element,
  secondElement: Element,
): number => {
  const position = firstElement.compareDocumentPosition(secondElement);

  if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
  if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
  return 0;
};
